import { render, staticRenderFns } from "./ComplianceDonut.vue?vue&type=template&id=23c6facc"
import script from "./ComplianceDonut.vue?vue&type=script&lang=js"
export * from "./ComplianceDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports